import FooterNavLink from "../components/FooterNavLink";

const NAV_LINKS = [
  { href: "#platform",       label: "Platform",         external: false },
  { href: "#intelligence",   label: "Intelligence",     external: false },
  { href: "#integrations",   label: "Integrations",     external: false },
  { href: "#pricing",        label: "Pricing",          external: false },
  { href: "#faqs",           label: "FAQ",              external: false },
  { href: "/privacy",        label: "Privacy Policy",   external: true  },
  { href: "/terms",          label: "Terms of Service", external: true  },
];

export default function FooterSection() {
  return (
    <footer id="footer" className="scroll-mt-24 bg-black text-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
        <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between sm:gap-8">
          {/* Brand */}
          <div className="space-y-3">
            <img
              src="/images/landing-v2/footer/shadowlabs-logo.svg"
              alt="ShadowLabs"
              className="h-10 w-auto select-none sm:h-12"
              draggable="false"
            />
            <p className="text-[13px] text-slate-500 max-w-xs leading-relaxed">
              Real-time intelligence for every revenue call.
            </p>
            <a
              href="mailto:hello@shadowlabs.ai"
              className="text-[13px] text-slate-500 hover:text-white transition-colors"
            >
              hello@shadowlabs.ai
            </a>
          </div>

          {/* Navigation */}
          <div className="sm:text-right">
            <p className="text-sm font-medium text-white mb-4">Navigation</p>
            <nav className="grid grid-cols-1 gap-2.5">
              {NAV_LINKS.map((link) => (
                <FooterNavLink key={link.href} href={link.href} external={link.external}>
                  {link.label}
                </FooterNavLink>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[12px] text-slate-600">© 2026 Shadow Labs. All rights reserved.</p>
          <p className="text-[12px] text-slate-600">Real-time intelligence · Built for revenue teams</p>
        </div>
      </div>
    </footer>
  );
}
